import { Nullable } from '@starsoft/common/interfaces';
import {
  SetCurrentTournamentTabPayload,
  SetTournamentsQueryPayload,
  TournamentsActions,
} from './props';
import { TournamentStatus } from '@/models/tournament/status';

export function setCurrentTournamentTab(
  payload: Nullable<TournamentStatus>,
): SetCurrentTournamentTabPayload {
  return { type: TournamentsActions.SetCurrentTab, payload };
}

export function SetTournamentQuery(
  payload: string,
): SetTournamentsQueryPayload {
  return { type: TournamentsActions.SetTournamentQuery, payload };
}
